module.exports = __webpack_public_path__ + "static/media/woo18.c562caba.png";